import { FaGithub, FaLinkedin } from "react-icons/fa";
import { SiGmail } from "react-icons/si";

export const SOCIAL__LINKS = [
	{
		id: "g1",
		name: "github",
		link: "https://github.com/AbdulrahmanAshraf98",
		icon: <FaGithub size={22} />,
	},
	{
		id: "l2",
		name: "linked",
		link: "https://www.linkedin.com/in/abdulrahmanashraf98/",
		icon: <FaLinkedin size={22} />,
	},
	{
		id: "g3",
		name: "gmail",
		link: "https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=abdulrahmanashraf2030@gmail.com",
		icon: <SiGmail size={22} />,
	},
];
